import React, { useState, useEffect } from "react";
import { Container, Typography } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import CustomButton from "../../components/Custom/CustomButton";
import SingleCustomCard from "../../components/Custom/SingleCustomCard";
import FinancialIcon from "../../assets/Icon/FinancialFpoIcon.png";
import LoaderContainer from "../../components/LoaderContainer";
import api from "../../globals/axios";
import { useNavigate } from "react-router-dom";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import ConfirmationPopup from "../../components/Popup/GenericPopup";
import { useAlert } from "../../components/Alert";
export default function Financials() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState(null);
  const { showAlert } = useAlert();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  useEffect(() => {
    api
      .get("/fpo/documents/")
      .then((response) => {
        if (response && response.data) {
          setDocuments(response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
        setLoading(false);
      });
  }, []);

  const handleView = (documentUrl) => {
    window.open(documentUrl, "_blank"); // Open document in a new tab
  };

  const downloadDocument = (documentId) => {
    window.open(
      `${SERVER_BASE_ADDRESS}/fpo/download_file/?identifier=${documentId}&file_type=document`
    );
  };
  const handleDelete = (documentId) => {
    setSelectedId(documentId);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    api.delete(`/fpo/document/${selectedId}/`).then((response) => {
      console.log("Document deleted successfully", response);
      setDocuments(documents.filter((doc) => doc.id !== selectedId));
      showAlert("success", "Deleted Successfully");
      window.location.reload();
    });
  };
  const handleAddDocuments = () => {
    navigate("/fpo/financials-documents");
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          {documents.length !== 0 && (
            <>
              <CustomTitle> {t("Financial")}</CustomTitle>
              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "calc(115vh - 200px)",
                  textAlign: "center",
                  height: "70vh",
                  margin: "auto",
                }}
              >
                {documents.map((data) => (
                  <SingleCustomCard
                    key={data.id}
                    data={[{ value: data.name }]}
                    onView={() => handleView(data.document)}
                    onUpload={() => downloadDocument(data.id)}
                    onDelete={() => handleDelete(data.id)}
                    showIcons={true}
                  />
                ))}
              </div>
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              height: documents.length !== 0 ? "20vh" : "90vh",
            }}
          >
            {documents.length === 0 && (
              <img
                src={FinancialIcon}
                alt="financial"
                style={{
                  width: "127px",
                  height: "127px",
                }}
              />
            )}
            <CustomButton onClick={handleAddDocuments}>
              {t("Add financial details")}
            </CustomButton>
            {documents.length === 0 && (
              <Typography variant="subtitle1">
                {t("Your details will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        message={t("Are you sure you want to delete this document?")}
        confirmButtonText={t("Delete")}
        cancelButtonText={t("Cancel")}
      />
    </>
  );
}
